// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"22caed24","239":"e18ab1d7","455":"4986ec07"}[chunkId] + ".chunk.js";
};